import styled from "styled-components";
import { motion } from "framer-motion";

export const PreloaderContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: var(--bg-base, #1e1e2e);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  overflow: hidden;

  .content {
    text-align: center;
    position: relative;
    z-index: 10;
  }

  .text-wrapper {
    overflow: hidden;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: 768px) {
      height: 60px;
    }
  }

  h1 {
    font-family: 'JetBrains Mono', 'Fira Code', monospace;
    font-size: 1.8rem;
    font-weight: 600;
    color: #cad3f5;
    margin: 0;
    padding: 0;
    line-height: 1;
    letter-spacing: 0.12rem;
    text-align: center;

    @media (min-width: 768px) {
      font-size: 2.4rem;
      letter-spacing: 0.15rem;
    }
    
    span {
      color: #8bd5ca; /* accent-teal */
    }
  }

  .line {
    width: 0;
    height: 2px;
    background: linear-gradient(90deg, #c6a0f6, #8bd5ca);
    margin: 12px auto 0 auto;
    border-radius: 2px;
  }

  .panel {
    position: absolute;
    width: 50%;
    height: 100%;
    background: var(--bg-base, #1e1e2e);
    z-index: 5;
  }

  .left-panel  { left: 0; }
  .right-panel { right: 0; }
`;
